<div
  class="header-container"
  [class.hide-stepper]="hideStepper"
>
  <a
    class="partner-logo"
    routerLink="/user/cases"
    [queryParams]="{ payee_case_reference_id }"
  >
    @if (showPartnerLogo) {
      @if (partnerLogoUrl) {
        <img
          class="logo"
          height="auto"
          width="170"
          [src]="partnerLogoUrl"
          [alt]="partnerLogoAlt"
        />
      } @else if (partnerLogoName) {
        <payee-icon
          height="auto"
          class="logo"
          [name]="partnerLogoName"
          [width]="partnerLogoName === 'payee-logo' ? '100px' : '170px'"
        ></payee-icon>
      }
    }
  </a>

  @if (!hideStepper) {
    <div class="stepper-wrapper flex vcenter hcenter">
      @for (step of steps; track step; let i = $index; let last = $last) {
        <button
          mat-button
          class="step-item"
          [class.active]="selectedStepIndex === i"
          (click)="navigateToStep(i)"
        >
          <div class="step-label">
            @if (i >= selectedStepIndex) {
              <span class="step-circle">
                {{ i + 1 }}
              </span>
            }
            @if (i < selectedStepIndex) {
              <svg
                class="step-check"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="11"
                  fill="#4caf50"
                />
                <path
                  d="M7.5 12.5l3 3 6-6"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
            <!-- TODO remove $any -->
            <span class="step-text">{{ $any(stepNames)[step] | async }}</span>
          </div>
        </button>
        @if (!last) {
          <div
            class="step-line"
            [class.completed]="i < selectedStepIndex"
          ></div>
        }
      }
    </div>
  }

  <div class="buttons-wrapper right">
    <payee-language-selector></payee-language-selector>
    <button
      class="exit-button"
      data-testid="case-form-exit"
      (click)="onExitButtonClick()"
    >
      {{ "CASE_FORM.HEADER.EXIT" | translate }}
    </button>
  </div>
</div>
